export default {"src":"/_next/static/media/WhoWeAre_042A.1e34e67c.JPG","height":700,"width":1920};